export interface IStorage {
    getItem: (key: string) => string | null | undefined;
    setItem: (key: string, value: string | null | undefined) => void;
    removeItem?: (key: string) => void;
}

import { MemoryStorage } from "./_memoryStorage";
import { CookieStorage } from "./_cookieStorage";
import { LocalStorage } from "./_localStorage";

const isLocalStorageEnabled = () => {
    let ret = true;
    try {
        let localStorage = new LocalStorage();
        if (localStorage) {
            localStorage.setItem("lstest", "test");
            ret = ret && window.localStorage.getItem("lstest") === "test";
            localStorage.removeItem("lstest");
        }
    } catch (err) {
        ret = false;
    }
    return ret;
};

const areCookiesEnabled = () => {
    try {
        if (!window.navigator || !window.navigator.cookieEnabled) {
            return false;
        }

        let cookieStorage = new CookieStorage();
        let testString = "" + Date.now();
        cookieStorage.setItem("CookieTest", "" + testString);
        if (cookieStorage.getItem("CookieTest") != testString) {
            return false;
        }

        cookieStorage.setItem("CookieTest", null);
        if (cookieStorage.getItem("CookieTest") !== null) {
            return false;
        }
    } catch (err) {
        return false;
    }

    return true;
};

const _createLocalStorage = (): IStorage => {
    if (isLocalStorageEnabled()) {
        return new LocalStorage();
    } else if (areCookiesEnabled()) {
        return new CookieStorage();
    } else {
        return new MemoryStorage();
    }
};


let storage = null;
let getLocalStorage = () => {
    if (storage) {
        return storage;
    }

    storage = _createLocalStorage();
    return getLocalStorage();
};

getLocalStorage();

export const localStorage = storage;
